import { SocioEmpresa } from "src/app/cnpj/components/quadro-societario/model/socio-empresa";

export const SOCIO_EMPRESA: SocioEmpresa[] = [
  {
    "cnpj": "02036483000100",
    "inCpfCnpjSocio": "1",
    "niSocio": "05519039000133",
    "qualificacaoSocio": "Sócio Pessoa Jurídica Domiciliado no Exterior",
    "dataInclusao": "19970725",
    "capitalSocial": 1.00,
    "cpfRepresentanteLegal": "85122220425",
    "qualificacaoRepresentanteLegal": "Procurador",
    "pais": "ALEMANHA",
    "nomeSocio": "KXMVQMHMVWD KWXGVKCXGK-HTFXIV BPOC"
  },
  {
    "cnpj": "02036483000100",
    "inCpfCnpjSocio": "1",
    "niSocio": "10559850000188",
    "qualificacaoSocio": "Sócio Pessoa Jurídica Domiciliado no Exterior",
    "dataInclusao": "20090106",
    "capitalSocial": 883551087.00,
    "cpfRepresentanteLegal": "85122220425",
    "qualificacaoRepresentanteLegal": "Procurador",
    "pais": "PAÍSES BAIXOS (HOLANDA)",
    "nomeSocio": "KXMVQMHMVWD BDXOWD CXDNQMB MHVCHIDWMNU O.E."
  },
  {
    "cnpj": "02036483000614",
    "inCpfCnpjSocio": "2",
    "niSocio": "85122220425",
    "qualificacaoSocio": "Administrador",
    "dataInclusao": "20160621",
    "capitalSocial": 0.00,
    "cpfRepresentanteLegal": "00000000000",
    "qualificacaoRepresentanteLegal": null,
    "pais": null,
    "nomeSocio": "HVITRL XZIOLH ILXSZ"
  },
  {
    "cnpj": "02036483000614",
    "inCpfCnpjSocio": "2",
    "niSocio": "25409791819",
    "qualificacaoSocio": "Administrador",
    "dataInclusao": "20210217",
    "capitalSocial": 0.00,
    "cpfRepresentanteLegal": "00000000000",
    "qualificacaoRepresentanteLegal": null,
    "pais": null,
    "nomeSocio": "Nome não encontrado na base CPF"
  }
]